module.exports = __webpack_public_path__ + "img/main-menu-cow888-13.84514dd9.png";